define('drops/modalAction/ModalActionMpa',[
    'jquery',
    'lq'
], function ($, lq) {
    'use strict';

    var dimensionsUpdateIntervalInMilliseconds = 300;

    var ModalActionMpa = function (modalAction) {
        this.modalAction = modalAction;

        this.onMessageReceived = this.receivedMessage.bind(this);
        this.sizeUpdateIntervaldId = null;
    };

    ModalActionMpa.prototype.setUp = function () {
        this.$iframe = $('<iframe />')
            .attr('scrolling', this.modalAction.data.scrolling)
            .css({
                width: '100%',
                height: '100%',
                border: 0,
                display: 'none',
                allowtransparency: true
            })
            .appendTo(this.modalAction.$element);
        window.addEventListener('message', this.onMessageReceived, false);
    };

    ModalActionMpa.prototype.tryGetIframeContentDocument = function () {
        var self = this;

        var contentWindow = self.$iframe[0].contentWindow;
        if (!contentWindow) {
            return;
        }

        try {
            return contentWindow.document
        }
        catch (e) {
            return;
        }
    }

    ModalActionMpa.prototype.retryLoadingIframe = function (iframeUrl, retryLoadCount) {
        var self = this;
        var initialRetries = 3;
        var additionalRetries = 5;
        var backoffDelay = 2;

        if (retryLoadCount <= (initialRetries + additionalRetries)) {
            var retryInterval = retryLoadCount <= initialRetries ? 0 : Math.pow(backoffDelay, retryLoadCount - initialRetries) * 1000;

            setTimeout(function () {
                self.$iframe.attr('src', iframeUrl);
            }, retryInterval);
        }
    }

    ModalActionMpa.prototype.show = function (actionId) {
        var self = this;
        var iframeUrl = this.getIframeUrl(actionId);
        var retryLoadCount = 0;

        this.$iframe
            .attr('src', iframeUrl)
            .css('display', 'inherit')
            .on('load', function () {
                var contentDocument = self.tryGetIframeContentDocument();
                if (!contentDocument) {
                    self.retryLoadingIframe(iframeUrl, ++retryLoadCount);
                }
            });

        if (!this.sizeUpdateIntervaldId && this.modalAction.$element.css('position') === 'relative') {
            this.$iframe.on('load', function () {
                //TODO kfe: let this inner action know that it's a modal
                if (self.sizeUpdateIntervaldId) return;

                self.sizeUpdateIntervaldId = setInterval(function () {
                    var contentDocument = self.tryGetIframeContentDocument();
                    if (!contentDocument) {
                        return;
                    }

                    var nestedLicquidContainer = $(contentDocument.body).find('.licquid-action-wrapper');
                    var theBody = $(contentDocument.body);
                    nestedLicquidContainer.children(".licquid-action-view").css("min-height", "auto");

                    if (nestedLicquidContainer.length === 0) return;

                    nestedLicquidContainer.css('overflow', 'hidden');

                    self.$iframe.width(theBody[0].scrollWidth);
                    self.modalAction.$element.width(theBody[0].scrollWidth);

                    // find the largest scrollHeight of all child views and apply it to the iframe and its content
                    var maxHeight = 0;
                    nestedLicquidContainer
                        .children()
                        .filter(function(i, v) {
                            if ($(v).hasClass('licquid-action-view')) return true; // current action's drops
                            var iframe = $(v).find('iframe')[0];
                            if (!iframe) return false;
                            var nestedContainer = $(iframe.contentWindow.document.body).find('.licquid-action-wrapper');
                            return !!nestedContainer.length;

                        }).each(function (i, v) {
                            maxHeight = Math.max(maxHeight, v.scrollHeight);
                        });
                    nestedLicquidContainer.css("height", maxHeight + 'px');

                    self.$iframe.height(nestedLicquidContainer[0].scrollHeight);
                    self.modalAction.$element.height(nestedLicquidContainer[0].scrollHeight);

                }, dimensionsUpdateIntervalInMilliseconds);
            });
        }
    };

    ModalActionMpa.prototype.hide = function () {
        if (!this.$iframe) return;

        if (this.sizeUpdateIntervaldId) {
            clearInterval(this.sizeUpdateIntervaldId);
            this.sizeUpdateIntervaldId = null;
        }

        this.$iframe
            .attr('src', '')
            .css('display', 'none');
    };

    ModalActionMpa.prototype.getIframeUrl = function (actionId) {
        if (!actionId) return 'about:blank';

        var targetUrl = lq.getTenantUrl('LicquidAction/Get/' + actionId);

        var params = {};

        var globals = this.modalAction.piping.parameters.globals.getAll();
        if (_.keys(globals).length > 0)
            params.globals = JSON.stringify(globals);

        var explicitlyMappedParams = this.modalAction.getParametersForIframe();
        if (_.keys(explicitlyMappedParams).length > 0)
            params.parameters = JSON.stringify(explicitlyMappedParams);

        return this.modalAction.piping.url.prepare(targetUrl, params);
    };

    ModalActionMpa.prototype.receivedMessage = function (message) {
        var eventObj = this.getEventFromMessage(message);
        if (!eventObj) return;

        if (eventObj.eventName === 'EmbeddedActionLoaded' && this.modalAction.data.useSelectedActionSize) {
            this.modalAction.setElementSizeBasedOnAnchoring(this.modalAction.data, eventObj);
        } else {
            // staying backwards compatible with existing custom code
            var args = eventObj.args ? eventObj.args[0] : null;
            this.modalAction.triggerEvent(this.modalAction.data.id + '.' + eventObj.eventName, args);
        }
    };

    ModalActionMpa.prototype.getEventFromMessage = function(e) {
        if (e.source !== this.$iframe.get(0).contentWindow)
            return undefined;

        try {
            var eventObj = JSON.parse(e.data);
            return eventObj;
        } catch (err) {
            //could not parse, ignore it
        }

        return undefined;
    }

    ModalActionMpa.prototype.triggerEventForChild = function (eventObj) {
        var targetOrigin = this.modalAction.rootDrop.data.embeddable
            ? '*'
            : window.location.protocol + '//' + window.location.host;
        this.$iframe.get(0).contentWindow.postMessage(JSON.stringify(eventObj), targetOrigin);
    };

    ModalActionMpa.prototype.onError = $.noop;

    ModalActionMpa.prototype.dispose = function() {
        window.removeEventListener('message', this.onMessageReceived);
    };

    return ModalActionMpa;
});

